<template>
    <!-- 素材分类标签四级归类单元格（workOrder_v4）：后端 material_label 为结构 {lv1..lv4, unknown_texts, multi_hits, text} -->
    <div class="ml-cell" v-if="v && typeof v === 'object'">
        <div class="ml-unknown" v-if="v.unknown_texts && v.unknown_texts.length">
            <el-tooltip effect="dark" placement="top" :content="'未知原文：' + v.unknown_texts.join('、')">
                <span>未知原文：{{ v.unknown_texts.join('、') }}</span>
            </el-tooltip>
        </div>
        <div class="ml-multi" v-if="v.multi_hits && v.multi_hits.length">
            <el-tooltip effect="dark" placement="top" :content="'多命中：' + v.multi_hits.join('；')">
                <span>多命中：{{ v.multi_hits.join('；') }}</span>
            </el-tooltip>
        </div>
        <template v-for="lv in [1, 2, 3, 4]">
            <div :key="lv" v-if="has(lv)" @dblclick="$emit('copy', v.text)">{{ names[lv] }}：{{ kv(lv) }}</div>
        </template>
        <span v-if="!has(1) && !has(2) && !has(3) && !has(4)">-</span>
    </div>
    <span v-else>{{ v || '-' }}</span>
</template>
<script>
export default {
    name: 'MaterialLabelCell',
    props: { v: [Object, String] },
    data() {
        return { names: { 1: '一级标签', 2: '二级标签', 3: '三级标签', 4: '四级标签' } }
    },
    methods: {
        has(lv) { const o = this.v && this.v['lv' + lv]; return !!o && Object.keys(o).length > 0 },
        kv(lv) { const o = this.v['lv' + lv]; return Object.keys(o).map(k => k + ':' + o[k]).join('，') },
    },
}
</script>
<style scoped>
.ml-cell { line-height: 18px; font-size: 12px; }
.ml-unknown, .ml-multi { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%; }
.ml-unknown { color: #f56c6c; }
.ml-multi { color: #e6a23c; }
</style>
